/**
 * Default review statuses that cannot be hidden (automation / core workflow).
 * DEV-19461
 */
export const SYSTEM_DEFAULT_REVIEW_STATUS_CODES = new Set<string>([
    'processed',
    'not_processed',
    'request_info',
    'answer_in_catalog',
    'abuse_sent',
    'review_deleted',
]);
